import { type MCPServerInfo } from '../../types';

const SupabaseServer: MCPServerInfo = {
  serverId: 'SUPABASE',
  name: 'Supabase',
  slug: 'supabase',
  description: 'Supabase MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'mcp/supabase:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: '@supabase/mcp-server-supabase'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['supabaseAccessToken'],
    properties: {
      supabaseAccessToken: {
        type: 'string',
        description: 'Supabase Access Token',
        sensitive: true
      },
      projectRef: {
        type: 'string',
        description: 'Project scoped to the connection',
        sensitive: true
      }
    }
  }
};

export default SupabaseServer;
